import { ReactNode } from 'react';
import styled from 'styled-components';

export interface CardProps {
  children: ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

const StyledCard = styled.article`
  display: flex;
  flex-direction: column;
  min-width: 10.9375rem;
  max-width: 12.5rem;
  min-height: 13.125rem;
  padding: 1rem 1rem 1.5rem 1rem;
  border-radius: 0.5rem;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.1);
`;

export const Card = ({ children, ...rest }: CardProps) => {
  return <StyledCard {...rest}>{children}</StyledCard>;
};

export default Card;
